export enum OfferView {
    OfferCategoryList = "OfferCategoryList",
    OfferList = "OfferList"
  }
  